/**
 * Created by StoneWang on 2020/11/30.
 */
import React from 'react';
import Reflux from 'reflux';
import {
    hashHistory,
} from 'react-router';
import {
    Input,
    Form,
    Select,
    Checkbox,
    Modal,
    Row,
    Col,
    Cascader,
    Button,
    Tooltip,
} from 'antd';
import {
    TableView,
} from '../../components';
import {
    getPro,
} from '../../service/order';
import {
    getProductCategory,
} from '../../service/product';
import {categoryTree} from '../../service/category';
import moment from 'moment';
import {
    openNotice,
    unique,
} from 'Utils';

const Option = Select.Option;
const FormItem = Form.Item;

class ProductList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.roleCode = JSON.parse(window.localStorage.getItem('login_user_information')).roleCode;
        this.state = {
            activeKey: 'product',
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end') || '{}'),
            visible: false,
            loading: false,
            selectedProducts: [], // 选择的产品
            selectedRowKeys: [], // 选择的产品 id
            catrgoryTree: [],
            channelCode: this.channelData.split('|')[1] || '',
            searchObj: {
                name: '', /*物料名称 筛选*/
                channelCode: this.channelData.split('|')[1] || '',
                stockType: '',
                proDetailType: '',
                proDetailTypeShow: [],
                delisting: false,
                historyOpen: false,
                s: 10,
                p: 1,
            },
            rows: [],
            total: 0,
            ts_disabled: false,
            showBackBtn: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.getCategory = this.getCategory.bind(this);
        this.getData = this.getData.bind(this);
        this.onSearchHandle = this.onSearchHandle.bind(this);
    };

    componentWillReceiveProps(newProps) {
        if (newProps.visible !== this.state.visible) {
            this.setState({
                visible: newProps.visible,
                searchObj: {
                    ...this.state.searchObj,
                    ...newProps.params,
                },
            }, () => {
                // if (this.state.visible) {
                //   this.getData();
                // }
            });
        }
    }

    componentDidMount() {
        const self = this;
        window.toggleShowBackBtn = this.toggleShowBackBtn;
        this.getCategory();
        window.addProduct = (record) => {
            self.addSave(record)
        };
    }

    componentWillUnmount() {
        window.toggleShowBackBtn = null;
        window.addProduct = null;
    }

    toggleShowBackBtn = (flag) => {
        this.setState({showBackBtn: flag});
    };

    //获取分类
    getCategory() {
        getProductCategory().then(res => {
            if (res.status) {
                const filterEmpty = (list, codePath) => list.map(x => {
                    let key = x.code; // 实际使用的业务数据是 code；
                    if (x.children && x.children.length) {
                        return {
                            ...x,
                            key: key, // 使用实际业务数据重新给 key 赋值
                            value: key, // 使用实际业务数据重新给 value 赋值
                            isLeaf: false,
                            // disableCheckbox: !x.categoryId,
                            codePath: [...codePath, {code: x.code, label: x.label, categoryId: x.categoryId}],
                            children: filterEmpty(x.children, [
                                ...codePath,
                                {code: x.code, label: x.label, categoryId: x.categoryId},
                            ]),
                        };
                    }
                    return {
                        ...x,
                        key: key, // 使用实际业务数据重新给 key 赋值
                        value: key, // 使用实际业务数据重新给 value 赋值
                        isLeaf: true,
                        // disableCheckbox: !x.categoryId,
                        codePath: [...codePath, {code: x.code, label: x.label, categoryId: x.categoryId}],
                        children: undefined,
                    };
                });
                const tree = filterEmpty(res.data || [], []);
                this.setState({
                    catrgoryTree: tree,
                });
            }
        });
    }

    goView(url) {
        hashHistory.push(url);
    };

    onSearchHandle(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                if (!values.name) {
                    openNotice('error', '请输入物料名称/编码');
                    return;
                }
                this.setState({
                    searchObj: {
                        ...this.state.searchObj,
                        ...values,
                        p: 1,
                    },
                }, () => {
                    this.getData();
                });
            }
        });
    }

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, () => {
            this.getData();
        });
    }

    getData() {
        let self = this;
        let searchObj = self.state.searchObj;
        self.setState({loading: true});
        getPro(searchObj).then(function (result) {
            if (result && result.code == 200) {
                result.data.forEach((item, i) => {
                    if (item.showPriceDate) {
                        result.data[i].showPriceDate = moment(result.data[i].showPriceDate).format('YYYY-MM-DD');
                    }
                });
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false,
                });
            } else {
                openNotice('error', '数据获取失败', '');
                self.setState({'loading': false});
            }
        });
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        const {selectedProducts} = this.state;
        let list = unique(selectedProducts.concat(selectedRows), 'id');
        this.setState({
            selectedRowKeys,
            selectedProducts: list,
        });
    };

    onOkHandle = () => {
        this.props.onOk(this.state.selectedProducts);
    };

    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    };

    stockChange = (value) => {
        let ts_disabled = false;
        let ts_checked = false;
        if (value === '') {
            ts_disabled = false;
            ts_checked = false;
        } else {
            ts_disabled = true;
            ts_checked = false;
        }
        this.setState({ts_disabled}, () => {
            this.props.form.setFieldsValue({
                delisting: ts_checked,
            });
        });
    };

    addSave = (record) => {
        const selectedProducts = [...this.props.selectedProducts];
        const productCodes = selectedProducts.map(x => x.productCode);
        if (productCodes.includes(record.itemNum)) {
            openNotice('warning', '商品已添加', null, 1);
            return;
        }
        selectedProducts.push({
            'productCode': record.itemNum, //产品物料编码
            'productDesc': record.name, //产品物料编码
            'price': record.showPrice, //牌价
            'downRate': 0, //下浮率（%）
            'downPrice': record.showPrice, //下浮价--牌价*(1-downRate)
            'count': 1, //数量
            'packageQuantity': record.packageQuantity, //装箱数
            'unit': record.unit, //单位
            'amount': record.showPrice, //产品金额
            'downAmount': 0, //优惠金额
            'realityAmount': record.showPrice, //实际金额
            'remark': '', // 备注（非必填）
        });
        openNotice('success', '商品添加成功', null, 1);
        this.props.addProduct(selectedProducts)
    };

    render() {
        const self = this;
        const roleCode = this.roleCode;
        const {
            visible, rows, total, searchObj, loading, button_limits_end,
            activeKey, ts_disabled, catrgoryTree, showBackBtn,
        } = this.state;
        const {getFieldDecorator, setFields} = this.props.form;
        const merchandiseUrl = `${window.location.href.split('#')[0]}#/mallSelect`;
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange,
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 90,
                },
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    width: 220,
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice',
                    width: 60,
                    render: (text, record, index) => {
                        if (roleCode != 'TG_SELLER_PRODUCT' && (record.itemManagerFlag == '' || record.itemManagerFlag == null || record.orderManagerFlag == '' || record.orderManagerFlag == null)) {
                            return (<span style={{color: '#d61518', height: 50}}>{'***'}</span>);
                        } else {
                            return (<span style={{color: '#d61518', height: 50}}>{'¥' + text}</span>);
                        }
                    },
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType',
                    width: 60,
                },
                {
                    title: '物料类别',
                    dataIndex: 'proBigName',
                    width: 220,
                    render: (text, record, index) => {
                        return <span>{`${record.proBigName}/${record.proMiddleName}/${record.proDetailName}`}</span>;
                    },
                },
                {
                    title: '历史开单量',
                    dataIndex: 'historyCount',
                    width: 70,
                },
                {
                    title: '操作',
                    dataIndex: 'save',
                    width: 150,
                    render: (text, record, index) => {
                        if (roleCode != 'TG_SELLER_PRODUCT' && (record.orderManagerFlag == '' || record.orderManagerFlag == null)) {
                            return (<span>该系列无开单权限，请联系各渠道审单人员开通下单权限</span>);
                        } else if (roleCode != 'TG_SELLER_PRODUCT' && (record.itemManagerFlag == '' || record.itemManagerFlag == null)) {
                            return (<span>该产品属于专属定制，您当前无下单权限。请将物料编码提交到定制订单，向生产公司申请开通下单权限。</span>);
                        } else {
                            return (<Button style={{background: '#red'}} icon="plus"
                                            onClick={this.addSave.bind(this, record, index)}>添加</Button>);
                        }
                    },
                },
            ],
            rows,
            // rowSelection: {
            //   selectedRowKeys,
            //   onChange: this.onSelectChange,
            // },
        };
        const modalProps = {
            width: this.props.width || 1400,
            visible: visible,
            bodyStyle: {
                overflow: 'hidden'
            },
            title: <span>
            {activeKey === 'product' ? '选择物料' : '商品选型选择'}（支持Enter回车查询）
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
                {button_limits_end.mallHome && <Button size="small"
                                                       onClick={() => this.setState({activeKey: activeKey === 'product' ? 'merchandise' : 'product'})}>{activeKey === 'product' ? '按商品选型' : '按物料选择'}</Button>}
                {showBackBtn && activeKey !== 'product' && <Button size="small"
                                                                   style={{float: 'right', marginRight: '30px'}}
                                                                   onClick={() => self.refs.mchIframe.contentWindow.history.go(-1)}>返回</Button>}
        </span>,
            onOk: () => this.onOkHandle(),
            onCancel: this.props.onCancel,
            footer: null,
        };
        return <Modal {...modalProps}>
            {activeKey === 'product' && <div>
                <Form layout="inline" onSubmit={this.onSearchHandle}>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={6}>
                            <FormItem label="物料名称/编码">
                                {getFieldDecorator('name', {
                                    initialValue: searchObj.name || '',
                                })(<Input placeholder="请输入客户名称" style={{width: '211px'}}/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={6}>
                            <div style={{display: 'none'}}>
                                <FormItem label="产品分类proDetailType">
                                    {getFieldDecorator('proDetailType', {
                                        initialValue: searchObj.proDetailType || '',
                                    })(<Input placeholder="请选择产品分类"/>)}
                                </FormItem>
                            </div>
                            <FormItem label="产品分类">
                                {getFieldDecorator('proDetailTypeShow', {
                                    initialValue: searchObj.proDetailTypeShow || undefined,
                                    getValueFromEvent: (value, selectedOptions) => {
                                        let lastOption = selectedOptions.pop();
                                        setFields({
                                            proDetailType: {
                                                value: lastOption ? lastOption.categoryId || '' : '',
                                                errors: undefined,
                                            },
                                        });
                                        return value;
                                    },
                                })(
                                    <Cascader
                                        style={{width: '224px'}}
                                        options={catrgoryTree}
                                        placeholder="请选择产品分类"
                                        showSearch={{filter: this.CascaderFilter}}
                                    />)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={4}>
                            <FormItem label="库存属性">
                                {getFieldDecorator('stockType', {
                                    initialValue: searchObj.stockType || '',
                                    getValueFromEvent: (e) => {
                                        this.stockChange(e);
                                        return e;
                                    },
                                })(<Select placeholder="请选择库存属性" style={{width: '128px'}}>
                                    <Option value="">全部</Option>
                                    <Option value="0">库存</Option>
                                    <Option value="1">非库存</Option>
                                    <Option value="2">定制</Option>
                                    <Option value="3">专属定制</Option>
                                </Select>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={3}>
                            <FormItem label={null} colon={false}>
                                {getFieldDecorator('delisting', {
                                    initialValue: searchObj.delisting || undefined,
                                })(<Checkbox disabled={ts_disabled}>
                                    退市产品
                                </Checkbox>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={3}>
                            <Tooltip placement="topLeft"
                                     title="从您历史一年的开单产品中搜索"
                                     arrowPointAtCenter>
                                <FormItem label={null} colon={false}>
                                    {getFieldDecorator('historyOpen', {
                                        initialValue: searchObj.historyOpen || false,
                                    })(<Checkbox>
                                        历史开单产品
                                    </Checkbox>)}
                                </FormItem>
                            </Tooltip>
                        </Col>
                        <Col className="gutter-row" span={2}>
                            <Button htmlType="submit">搜索</Button>
                        </Col>
                    </Row>
                </Form>
                <TableView {...tableViewProps} bordered style={{marginTop: 10}}/>
            </div>}
            {activeKey === 'merchandise' && <div style={{minHeight: 697}}>
                <iframe ref="mchIframe" src={merchandiseUrl} style={{width: '100%', height: 697, border: 0}}></iframe>
            </div>}
        </Modal>;
    }
}
;
export default Form.create()(ProductList);



// WEBPACK FOOTER //
// ./src/routes/quotation/productModal.js